module.exports = __webpack_public_path__ + "static/room02-b8a61a7c50541a5e1c0d68ba777f53b4.jpg";